import Axios from 'axios'
import React, { Component } from 'react'
import ReadAxios from '../axiosComponent/readAxios'

export default class cityNameRenderer extends Component {

    state = {
        cityNames: []
    }

    componentDidMount() {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster/${this.props.data.address}`, method: "post",
        }).then((res) => {
            if (res.status === 200) {
                let name = res.data.resultSet[0] ? res.data.resultSet[0]['cityName'] : ""
                this.setState({
                    cityNames: name
                })
            }
        })
    }


    render() {
        return (
            <div>
                {/* {this.state.cityNames.length > 0 ? 
                this.state.cityNames.map((o,i)=>(
                    <>{o}</>
                )):''} */}
                {this.state.cityNames}
            </div>
        )
    }
}
